/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Body_Assessment_Cue_Frame_Head_FeetInputs */

const en_us2_body_assessment_cue_frame_head_feet = /** @type {(inputs: Body_Assessment_Cue_Frame_Head_FeetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Head and feet inside the frame.`)
};

const pt_br2_body_assessment_cue_frame_head_feet = /** @type {(inputs: Body_Assessment_Cue_Frame_Head_FeetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pés e cabeça no enquadramento.`)
};

const es_419_body_assessment_cue_frame_head_feet = /** @type {(inputs: Body_Assessment_Cue_Frame_Head_FeetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cabeza y pies dentro del encuadre.`)
};

const pt_pt2_body_assessment_cue_frame_head_feet = /** @type {(inputs: Body_Assessment_Cue_Frame_Head_FeetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pés e cabeça no enquadramento.`)
};

const fr_fr2_body_assessment_cue_frame_head_feet = /** @type {(inputs: Body_Assessment_Cue_Frame_Head_FeetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`La tête et les pieds dans le cadre.`)
};

const de_de2_body_assessment_cue_frame_head_feet = /** @type {(inputs: Body_Assessment_Cue_Frame_Head_FeetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kopf und Füße ins Bild.`)
};

const it_it2_body_assessment_cue_frame_head_feet = /** @type {(inputs: Body_Assessment_Cue_Frame_Head_FeetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Testa e piedi nell'inquadratura.`)
};

/**
* | output |
* | --- |
* | "Head and feet inside the frame." |
*
* @param {Body_Assessment_Cue_Frame_Head_FeetInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const body_assessment_cue_frame_head_feet = /** @type {((inputs?: Body_Assessment_Cue_Frame_Head_FeetInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Body_Assessment_Cue_Frame_Head_FeetInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_body_assessment_cue_frame_head_feet(inputs)
	if (locale === "es-419") return es_419_body_assessment_cue_frame_head_feet(inputs)
	if (locale === "pt-PT") return pt_pt2_body_assessment_cue_frame_head_feet(inputs)
	if (locale === "fr-FR") return fr_fr2_body_assessment_cue_frame_head_feet(inputs)
	if (locale === "de-DE") return de_de2_body_assessment_cue_frame_head_feet(inputs)
	if (locale === "it-IT") return it_it2_body_assessment_cue_frame_head_feet(inputs)
	return en_us2_body_assessment_cue_frame_head_feet(inputs)
});
export { body_assessment_cue_frame_head_feet as "body-assessment.cue.frame_head_feet" }